import { API_URL} from './http';

const login = () => `${API_URL}/login`;
const deviceToken=()=>`${API_URL}/employers/current/device-token`
const deleteToken=()=>`${API_URL}/employers/current/logout`
const loginCA = () => `${API_URL}/campus-ambassador/validate`;
const getOtp = () => `${API_URL}/students/send-verification-code`;
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    login,
    deviceToken,
    deleteToken,
    loginCA,
    getOtp
}
